import { isServer } from '../environment';
import { IWixSdk } from '@wix/js-sdk-wrapper';

const Wix: IWixSdk = !isServer ? require('@wix/js-sdk-wrapper').WixSdk : {};

function subscribe(event, fn) {
  Wix.addEventListener(event, fn);

  return () => {
    Wix.removeEventListener(event, fn);
  };
}

function appendDocumentTitle(newPrefix: string) {
  if (newPrefix.length > 250) {
    newPrefix = `${newPrefix.substring(0, 250)}...`;
  }

  if (Wix.Utils?.getViewMode?.() === 'site' && Wix.setPageMetadata) {
    Wix.setPageMetadata({
      title: `${newPrefix} | ${document?.title}`,
    });
  }
}

export { subscribe, appendDocumentTitle };

export default Wix;
